// API service for patient odontogram management
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class PatientOdontogramService {
  /**
   * Get patient odontogram (creates if doesn't exist)
   */
  static async getPatientOdontogram(patientId, token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient-odontograms/patient/${patientId}`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error getting patient odontogram:', error);
      throw error;
    }
  }

  /**
   * Update initial odontogram
   */
  static async updateInitialOdontogram(patientId, data, token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient-odontograms/patient/${patientId}/initial`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('Error updating initial odontogram:', error);
      throw error;
    }
  }

  /**
   * Update evolution odontogram
   */
  static async updateEvolutionOdontogram(patientId, data, token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient-odontograms/patient/${patientId}/evolution`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('Error updating evolution odontogram:', error);
      throw error;
    }
  }

  /**
   * Update odontogram mode (adult/pediatric)
   */
  static async updateMode(patientId, mode, token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient-odontograms/patient/${patientId}/mode`,
        {
          method: 'PATCH',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ mode }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('Error updating odontogram mode:', error);
      throw error;
    }
  }

  /**
   * Discharge patient (archive current odontograms and clear)
   */
  static async dischargePatient(patientId, token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient-odontograms/patient/${patientId}/discharge`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({}),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response.json();
    } catch (error) {
      console.error('Error discharging patient:', error);
      throw error;
    }
  }

  /**
   * Get discharge history
   */
  static async getDischargeHistory(patientId, token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/patient-odontograms/patient/${patientId}/discharge-history`,
        {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error getting discharge history:', error);
      throw error;
    }
  }
}

export default PatientOdontogramService;
